(() => {
  'use strict';

  function init() {
    const desktop = document.querySelector('[data-mf-desktop-nav]');
    const drawer = document.querySelector('.mf-nav-2026[data-mobile-menu]');
    const hamburger = document.querySelector('[data-hamburger]');
    const header = document.querySelector('header.header');
    if (!desktop || !drawer || !hamburger || desktop.dataset.mfReady) return;
    desktop.dataset.mfReady = 'true';
    const boundary = matchMedia('(min-width: 1024px)');
    const hover = matchMedia('(any-hover: hover)');
    const overlay = document.querySelector('.mf-nav-2026[data-mobile-overlay]');
    const searchToggle = document.querySelector('[data-mf-search-toggle]');
    const search = document.getElementById('mobileSearchHolder');
    const rootPanel = document.getElementById('mf-mobile-root');
    const panels = [...drawer.querySelectorAll('[data-mf-mobile-panel]')];
    const stack = [];
    const inerted = new Map();
    let active = null;
    let pointerItem = null;
    let transition = null;
    let transitionTimer;
    let open = false;
    let searchOpen = false;
    let scrollY = 0;
    let currentPanel = rootPanel;

    function reportOpen(area, section, item) {
      document.dispatchEvent(new CustomEvent('mf:nav-open', {detail: {area, section, item}}));
    }

    function clearTimers() {
      clearTimeout(transitionTimer);
      transition = null;
    }

    function closeDesktop(returnFocus = false) {
      clearTimers();
      if (!active) return;
      const trigger = active.querySelector('[data-navbar-trigger]');
      const panel = active.querySelector('[data-mf-desktop-panel]');
      panel.inert = true;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      active = null;
      desktop.classList.remove('has-active-panel');
      if (returnFocus) trigger.focus({preventScroll: true});
    }

    function openDesktop(item) {
      clearTimers();
      if (!boundary.matches || active === item) return;
      closeDesktop();
      active = item;
      const trigger = item.querySelector('[data-navbar-trigger]');
      const panel = item.querySelector('[data-mf-desktop-panel]');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.inert = false;
      desktop.classList.add('has-active-panel');
      syncMeasurements();
      reportOpen('desktop_menu', item.dataset.mfNavItem, 'menu');
    }

    function planTransition(action, item = null, force = false) {
      clearTimers();
      if (action === 'close' && !active) return;
      const next = {action, item, force};
      transition = next;
      transitionTimer = setTimeout(() => {
        if (transition !== next) return;
        transition = null;
        if (action === 'open' && pointerItem === item) openDesktop(item);
        else if (action === 'close' && !pointerItem) {
          if (force || !active?.querySelector('[data-mf-desktop-panel]').contains(document.activeElement)) closeDesktop();
        }
      }, 300);
    }

    function pointerRegion(target) {
      if (!(target instanceof Element)) return null;
      const region = target.closest('[data-navbar-trigger],[data-mf-desktop-panel]');
      return region && desktop.contains(region) ? region : null;
    }
    desktop.querySelectorAll('[data-navbar-item]').forEach(item => {
      const trigger = item.querySelector('[data-navbar-trigger]');
      const panel = item.querySelector('[data-mf-desktop-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', () => active === item ? closeDesktop() : openDesktop(item));
    });
    desktop.addEventListener('pointerover', event => {
      if (!boundary.matches || !hover.matches || event.pointerType === 'touch') return;
      const region = pointerRegion(event.target);
      if (!region || region === pointerRegion(event.relatedTarget)) return;
      pointerItem = region.closest('[data-navbar-item]');
      if (pointerItem === active) clearTimers();
      else planTransition('open', pointerItem);
    });
    desktop.addEventListener('pointerout', event => {
      if (!boundary.matches || !hover.matches || event.pointerType === 'touch') return;
      const region = pointerRegion(event.target);
      if (!region || region === pointerRegion(event.relatedTarget)) return;
      pointerItem = null;
      planTransition('close');
    });
    const leaveDocument = () => {
      if (!boundary.matches) return;
      pointerItem = null;
      planTransition('close', null, true);
    };
    document.addEventListener('pointerout', event => {
      if (!event.relatedTarget && event.pointerType !== 'touch') leaveDocument();
    });
    window.addEventListener('blur', leaveDocument);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { pointerItem = null; closeDesktop(); }
    });
    desktop.addEventListener('focusout', event => {
      if (event.relatedTarget && desktop.contains(event.relatedTarget)) return;
      queueMicrotask(() => {
        if (!desktop.contains(document.activeElement)) closeDesktop();
      });
    });
    document.addEventListener('click', event => {
      if (active && !desktop.contains(event.target)) closeDesktop();
    });

    function setInert(element) {
      if (!inerted.has(element)) inerted.set(element, element.inert);
      element.inert = true;
    }

    function excludeBackground() {
      [...document.body.children].forEach(element => {
        if (element !== drawer && element !== overlay && element !== header
          && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) setInert(element);
      });
      header.querySelectorAll('a,button,input').forEach(element => {
        if (element !== hamburger) setInert(element);
      });
    }
    const backgroundObserver = new MutationObserver(() => {
      if (open) excludeBackground();
    });

    function resetPanels() {
      stack.length = 0;
      currentPanel = rootPanel;
      panels.forEach(panel => {
        panel.hidden = panel !== rootPanel;
        panel.inert = panel !== rootPanel;
      });
      drawer.querySelectorAll('[data-mf-drill]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      drawer.querySelector('nav').scrollTop = 0;
    }

    function blockScroll(event) {
      if (open && !drawer.contains(event.target) && event.cancelable) event.preventDefault();
    }

    // The compiled bundle is the sole click opener. Observe its state, never toggle it here.
    function syncDrawer() {
      const next = drawer.classList.contains('is-active');
      if (next === open) return;
      open = next;
      hamburger.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open;
      overlay.hidden = !open;
      document.body.classList.toggle('mf-nav-2026-open', open);
      document.documentElement.classList.toggle('mf-nav-2026-open', open);
      if (open) {
        setSearch(false);
        scrollY = window.scrollY;
        resetPanels();
        header.classList.remove('header-hidden');
        excludeBackground();
        backgroundObserver.observe(document.body, {childList: true});
        document.addEventListener('touchmove', blockScroll, {passive: false});
        document.addEventListener('wheel', blockScroll, {passive: false});
        rootPanel.querySelector('h2').focus({preventScroll: true});
        reportOpen('mobile_menu', 'mobile', 'menu');
      } else {
        backgroundObserver.disconnect();
        document.removeEventListener('touchmove', blockScroll);
        document.removeEventListener('wheel', blockScroll);
        inerted.forEach((value, element) => { element.inert = value; });
        inerted.clear();
        resetPanels();
        window.scrollTo(0, scrollY);
        if (!boundary.matches) hamburger.focus({preventScroll: true});
      }
    }
    new MutationObserver(syncDrawer).observe(drawer, {attributes: true, attributeFilter: ['class']});

    // Every dismissal uses the same state cleanup path.
    function closeDrawer() {
      if (!drawer.classList.contains('is-active')) return;
      drawer.classList.remove('is-active');
      drawer.classList.add('-translate-x-full');
      hamburger.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden', 'mobile-nav-open');
      syncDrawer();
    }
    drawer.querySelector('[data-mobile-menu-close]')?.addEventListener('click', event => {
      event.preventDefault();
      // The bundle also toggles this button; do not let it reopen the closed drawer.
      event.stopImmediatePropagation();
      closeDrawer();
    });
    overlay.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', event => {
      const drill = event.target.closest('[data-mf-drill]');
      const back = event.target.closest('[data-mf-back]');
      if (drill && open && currentPanel.contains(drill)) {
        const next = document.getElementById(drill.getAttribute('aria-controls'));
        if (!next) return;
        stack.push({panel: currentPanel, opener: drill, scrollTop: drawer.querySelector('nav').scrollTop});
        drill.setAttribute('aria-expanded', 'true');
        currentPanel.hidden = true;
        currentPanel.inert = true;
        currentPanel = next;
        next.hidden = false;
        next.inert = false;
        drawer.querySelector('nav').scrollTop = 0;
        next.querySelector('h2').focus({preventScroll: true});
        reportOpen('mobile_menu', drill.dataset.mfNavItem, 'submenu');
      } else if (back && stack.length) {
        currentPanel.hidden = true;
        currentPanel.inert = true;
        const previous = stack.pop();
        currentPanel = previous.panel;
        currentPanel.hidden = false;
        currentPanel.inert = false;
        previous.opener.setAttribute('aria-expanded', 'false');
        drawer.querySelector('nav').scrollTop = previous.scrollTop;
        previous.opener.focus({preventScroll: true});
      }
    });

    function focusables() {
      return [...drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex="0"]')]
        .filter(element => !element.closest('[hidden],[inert]') && element.getClientRects().length);
    }
    document.addEventListener('focusin', event => {
      if (open && !drawer.contains(event.target)) {
        (focusables()[0] || currentPanel.querySelector('h2')).focus({preventScroll: true});
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (open) { event.preventDefault(); closeDrawer(); }
        else if (searchOpen) { event.preventDefault(); setSearch(false, true); }
        else if (active) { event.preventDefault(); closeDesktop(true); }
      }
      if (event.key !== 'Tab' || !open) return;
      const controls = focusables();
      const first = controls[0];
      const last = controls[controls.length - 1];
      const focused = document.activeElement;
      if (event.shiftKey && (focused === first || !controls.includes(focused))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && focused === last) {
        event.preventDefault();
        first?.focus();
      }
    });

    function setSearch(next, returnFocus = false) {
      if (!search || !searchToggle) return;
      searchOpen = next && !boundary.matches;
      search.hidden = !searchOpen;
      search.classList.toggle('hidden', !searchOpen);
      searchToggle.setAttribute('aria-expanded', String(searchOpen));
      searchToggle.querySelector('i').classList.toggle('icon-close', searchOpen);
      searchToggle.querySelector('i').classList.toggle('icon-search', !searchOpen);
      header.classList.remove('header-hidden');
      syncMeasurements();
      if (searchOpen) {
        search.querySelector('input[type="search"]').focus({preventScroll: true});
      } else if (returnFocus && !boundary.matches) searchToggle.focus({preventScroll: true});
    }
    searchToggle?.addEventListener('click', () => setSearch(!searchOpen));

    function syncMeasurements() {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--mnav-navbar-h', height + 'px');
      document.documentElement.style.setProperty('--header-h', height + 'px');
      document.documentElement.style.setProperty('--navbar-logo-header-height', height + 'px');
      const spacer = document.querySelector('.header-spacer');
      if (spacer && !boundary.matches) spacer.style.height = height + 'px';
      desktop.style.setProperty('--mf-nav-panel-top', Math.max(0, desktop.getBoundingClientRect().bottom) + 'px');
      if (active) {
        const panel = active.querySelector('[data-mf-desktop-panel]');
        const trigger = active.querySelector('[data-navbar-trigger]').getBoundingClientRect();
        const nav = desktop.getBoundingClientRect();
        const width = panel.getBoundingClientRect().width;
        const left = Math.max(16, Math.min(trigger.left + trigger.width / 2 - width / 2,
          document.documentElement.clientWidth - width - 16));
        panel.style.setProperty('--mf-nav-dropdown-left', (left - nav.left) + 'px');
        active.style.setProperty('--mf-nav-pointer-bridge',
          Math.max(0, panel.getBoundingClientRect().top - trigger.bottom) + 'px');
      }
    }
    new ResizeObserver(syncMeasurements).observe(header);
    window.addEventListener('resize', syncMeasurements);
    boundary.addEventListener('change', () => {
      closeDesktop();
      closeDrawer();
      setSearch(false);
      syncMeasurements();
    });
    syncMeasurements();
    const ready = () => { hamburger.disabled = false; };
    if (document.readyState === 'complete') ready();
    else window.addEventListener('load', ready, {once: true});

    // Preserve the existing measured desktop fixed/header scroll behaviour.
    if (!boundary.matches) return;
    let naturalTop = desktop.offsetTop;
    let navHeight = desktop.offsetHeight;
    let headerHeight = header.offsetHeight;
    let snapshot = window.pageYOffset || 0;
    let fixed = false;
    let hidden = false;
    let ticking = false;
    const spacer = document.createElement('div');
    spacer.className = 'mf-nav-2026__desktop-spacer';
    spacer.style.height = (navHeight + headerHeight) + 'px';
    spacer.style.display = 'none';
    desktop.after(spacer);

    function measurements() {
      headerHeight = header.offsetHeight;
      navHeight = desktop.offsetHeight;
      spacer.style.height = (navHeight + headerHeight) + 'px';
      syncMeasurements();
    }
    function positions() {
      header.style.top = '0px';
      desktop.style.top = headerHeight + 'px';
      syncMeasurements();
    }
    function resetFixed() {
      desktop.classList.remove('navbar-builder--fixed', 'navbar-builder--hidden', 'navbar-builder--compact');
      desktop.style.top = '';
      spacer.style.display = 'none';
      header.classList.remove('header--desktop-fixed', 'header--desktop-hidden');
      header.style.top = '';
      fixed = false;
      hidden = false;
      snapshot = 0;
    }
    function updateScroll() {
      ticking = false;
      if (!boundary.matches) return;
      const y = window.pageYOffset;
      const difference = y - snapshot;
      if (y >= naturalTop && !fixed) {
        measurements();
        header.classList.add('header--desktop-fixed');
        header.classList.remove('header--desktop-hidden');
        desktop.classList.add('navbar-builder--fixed');
        positions();
        spacer.style.display = 'block';
        fixed = true;
        snapshot = y;
      }
      if (!fixed) return;
      positions();
      if (y <= 0) { resetFixed(); return; }
      if (active || desktop.contains(document.activeElement) || header.contains(document.activeElement)) {
        snapshot = y;
        return;
      }
      if (difference > 10 && !hidden) {
        closeDesktop();
        header.classList.add('header--desktop-hidden');
        desktop.classList.add('navbar-builder--hidden');
        hidden = true;
      } else if (difference < -10 && hidden) {
        header.classList.remove('header--desktop-hidden');
        desktop.classList.remove('navbar-builder--hidden');
        hidden = false;
      }
      if (Math.abs(difference) > 10) snapshot = y;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateScroll); ticking = true; }
    }, {passive: true});
    window.addEventListener('resize', () => {
      if (!boundary.matches) { resetFixed(); return; }
      measurements();
      if (fixed) positions();
      else naturalTop = desktop.offsetTop;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
